/*
 * Trinh thiet ke day dong ho 3D (giao dien + quy tac + gia + gio hang).
 * Du lieu (data) do section Shopify doc tu Metaobjects va truyen vao:
 *   data.styles   [{handle, name, image, video, sort, active, model_url, price_regular|exotic|non_leather, engraving, rules}]
 *   data.options  {handle: {group, name, price, image, tooltip, color, active}}
 *   data.leathers [{handle, name, family, tier, swatch, artwork, uv_map, roughness, tone_color, stitching_tone_color,
 *                   unsupported_stitching|curved|padded|styles, no_folded_edge, price, out_of_stock, active}]
 *   data.linings  [{handle, name, family, swatch, artwork, uv_map, roughness, unsupported_stitching, no_folded_edge, price, out_of_stock, active}]
 *   data.assets   {hdr, shadow, thread, metal, logo}  (logo: anh logo khac len lot, de trong = khong khac logo)
 * opts: {initialStyle, showPicker, variantForPrice(price) -> id, addToCart(id, properties) -> Promise, onAdded(checkout), designUrl(code)}
 */
(function (global) {
  "use strict";
  var TIER_KEY = { Regular: "regular", Exotic: "exotic", "Non-leather": "non_leather" };
  var META = ["_dial", "_measure", "_text", "_edge", "_leather", "_lining", "_nologo", "_holes"];

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === "class") e.className = attrs[k];
      else if (k === "text") e.textContent = attrs[k];
      else if (k.slice(0, 2) === "on") e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? "" : attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) e.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return e;
  }
  // Gia goc tinh bang USD; khach o thi truong khac thay gia quy doi theo tien te dang xem (Shopify.currency)
  function money(n) {
    var cur = global.Shopify && global.Shopify.currency, v = Number(n || 0);
    if (cur && cur.active && cur.active !== "USD" && Number(cur.rate)) {
      try { return new Intl.NumberFormat("en-US", { style: "currency", currency: cur.active, maximumFractionDigits: cur.active === "VND" || cur.active === "JPY" || cur.active === "KRW" ? 0 : 2 }).format(cur.active === "VND" ? Math.round(v * Number(cur.rate) / 1000) * 1000 : v * Number(cur.rate)); } catch (e) { /* tien te la -> USD */ }
    }
    return "$" + (Math.round(v * 100) / 100).toLocaleString("en-US");
  }
  function lower(s) { return (s || "").toLowerCase().trim(); }
  function names(list) { return (list || []).map(function (x) { return lower(typeof x === "string" ? x : x && x.name); }); }
  function tierOfTerm(name) {
    var n = lower(name);
    return n.indexOf("exotic") === 0 ? "Exotic" : n.indexOf("non") === 0 ? "Non-leather" : "Regular";
  }
  function encode(obj) { return btoa(unescape(encodeURIComponent(JSON.stringify(obj)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); }
  function decode(s) {
    try { s = s.replace(/-/g, "+").replace(/_/g, "/"); return JSON.parse(decodeURIComponent(escape(atob(s)))); } catch (e) { return null; }
  }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }

  function Configurator(root, data, opts) {
    this.root = root;
    this.data = data;
    this.opts = opts || {};
    this.styles = (data.styles || (data.style ? [data.style] : []))
      .filter(function (s) { return s.active !== false && s.model_url && s.rules; })
      .sort(function (a, b) { return (a.sort || 0) - (b.sort || 0); });
    this.state = {};
    this.leatherBy = {};
    this.liningBy = {};
    var self = this;
    data.leathers.forEach(function (l) { self.leatherBy[l.handle] = l; });
    data.linings.forEach(function (l) { self.liningBy[l.handle] = l; });
  }

  // ---------- Truy van du lieu ----------
  Configurator.prototype.group = function (type) { return (this.groups || []).find(function (g) { return g.type === type; }); };
  Configurator.prototype.entry = function (g, handle) {
    return (g && g.options.find(function (o) { return o.option === handle; })) || null;
  };
  Configurator.prototype.selEntry = function (type) { var g = this.group(type); return g ? this.entry(g, this.state[g.key]) : null; };
  Configurator.prototype.opt = function (handle) { return this.data.options[handle] || {}; };
  Configurator.prototype.activeEntries = function (g) {
    var self = this;
    return g.options.filter(function (o) { return self.opt(o.option).active !== false; });
  };
  Configurator.prototype.priceOf = function (g, handle) {
    var e = this.entry(g, handle);
    if (!e) return 0;
    return e.price != null ? Number(e.price) : Number(this.opt(handle).price || 0);
  };
  Configurator.prototype.leatherAllowed = function (l) {
    return l.active !== false && names(l.unsupported_styles).indexOf(lower(this.style.name)) < 0;
  };
  Configurator.prototype.leathersForTier = function (tier) {
    var self = this, fams = (this.rules.leather_families || {})[TIER_KEY[tier]] || [];
    return this.data.leathers.filter(function (l) { return l.tier === tier && fams.indexOf(l.family) >= 0 && self.leatherAllowed(l); });
  };
  Configurator.prototype.liningsForFamily = function (fam) {
    return this.data.linings.filter(function (l) { return l.family === fam && l.active !== false; });
  };
  // Nhom khac chu: lua chon "chu khac" va lua chon "bo logo" (doc lap). Chua cai logo -> an lua chon bo logo.
  Configurator.prototype.initialsParts = function (g) {
    var self = this, text = null, nologo = null;
    g.options.forEach(function (o) {
      var t = ((o.extra || {}).initialType || {}).value || "", n = lower(self.opt(o.option).name);
      if (t === "Engrave logo" || n.indexOf("no engrave") >= 0) nologo = o; else if (!text) text = o;
    });
    return { text: text, nologo: this.data.assets.logo ? nologo : null };
  };

  Configurator.prototype.currentLeather = function () { return this.leatherBy[this.state._leather]; };
  Configurator.prototype.currentLining = function () { return this.liningBy[this.state._lining]; };

  // ---------- Kich thuoc ----------
  Configurator.prototype.measureChildren = function () {
    var e = this.selEntry("Measurements");
    return (e && e.extra && e.extra.children) || [];
  };
  Configurator.prototype.measureKey = function (k) { return (k.config || {}).type || k.name; };
  Configurator.prototype.measureValue = function (key) {
    var g = this.group("Measurements"), m = g && this.state._measure[g.key];
    return m ? m[key] : null;
  };
  Configurator.prototype.lugWidth = function () { var v = parseFloat(this.measureValue("lugWidth")); return isNaN(v) ? null : v; };
  Configurator.prototype.buckleWidth = function () { var v = parseFloat(this.measureValue("buckleWidth")); return isNaN(v) ? null : v; };
  Configurator.prototype.thicknessChoices = function () {
    var g = this.group("Drop down"), e = g && this.activeEntries(g)[0];
    var all = (e && e.extra && e.extra.choices) || [];
    var padded = this.selEntry("Padded"), rel = padded && padded.extra && padded.extra.dropdownConfigRelative;
    if (rel && rel.relativeConfig && rel.relativeConfig.length) {
      var allowed = rel.relativeConfig.map(lower);
      var filtered = all.filter(function (c) { return allowed.indexOf(lower(c.value || c.name)) >= 0; });
      if (filtered.length) return filtered;
    }
    return all;
  };

  // ---------- Quy tac khong tuong thich (lam lai tu app cu) ----------
  /** Tra ve ly do khong chon duoc lua chon nay, hoac null neu chon duoc. */
  Configurator.prototype.blocked = function (g, entry) {
    var o = this.opt(entry.option), name = lower(o.name), ex = entry.extra || {};
    var lea = this.currentLeather(), lin = this.currentLining(), lug = this.lugWidth(), bw = this.buckleWidth();
    switch (g.type) {
      case "Stitching":
        if (lea && names(lea.unsupported_stitching).indexOf(name) >= 0) return "Not available with " + lea.name;
        if (lin && names(lin.unsupported_stitching).indexOf(name) >= 0) return "Not available with " + lin.name + " lining";
        if (ex.unSupportSmallerLugWidth && lug && lug < ex.unSupportSmallerLugWidth) return "Needs lug width ≥ " + ex.unSupportSmallerLugWidth + " mm";
        break;
      case "Curved end":
        if (lea && names(lea.unsupported_curved).indexOf(name) >= 0) return "Not available with " + lea.name;
        break;
      case "Padded":
        if (lea && names(lea.unsupported_padded).indexOf(name) >= 0) return "Not available with " + lea.name;
        break;
      case "Quick bars":
        var curved = this.selEntry("Curved end"), curvedName = curved && lower(this.opt(curved.option).name);
        if (curvedName && names(ex.unsupportedCurvedEnd).indexOf(curvedName) >= 0) return "Not available with curved end";
        if (ex.unSupportSmallerLugWidth && lug && lug < ex.unSupportSmallerLugWidth) return "Needs lug width ≥ " + ex.unSupportSmallerLugWidth + " mm";
        break;
      case "Buckle":
        if (ex.supportSize && ex.supportSize.length && bw && ex.supportSize.map(Number).indexOf(bw) < 0) return "Not available for " + bw + " mm buckle width";
        break;
      case "Edge finishing":
        if (ex.type === "Folded") {
          if (lea && lea.no_folded_edge) return "Folded edges are not available for " + lea.name;
          if (lin && lin.no_folded_edge) return "Folded edges are not available with " + lin.name + " lining";
          var self = this, blocker = this.groups.find(function (gg) {
            var se = self.entry(gg, self.state[gg.key]);
            return se && se.extra && se.extra.supportEdgeFolded === false;
          });
          if (blocker) return "Folded edges are not available with this " + blocker.name.toLowerCase();
        }
        break;
    }
    return null;
  };

  Configurator.prototype.hidden = function (g) {
    if (g.type === "Color of stitch") {
      var st = this.selEntry("Stitching");
      return !!(st && st.extra && st.extra.isNoStitches);
    }
    return g.type === "Attach file";
  };

  /** Sua trang thai sau moi thay doi: bo lua chon khong hop le, chon lai cai hop le dau tien. */
  Configurator.prototype.fix = function () {
    var self = this, s = this.state, notes = [];
    var lea = this.currentLeather();
    if (!lea || !this.leatherAllowed(lea)) {
      var any = ["Regular", "Exotic", "Non-leather"].reduce(function (acc, t) { return acc.concat(self.leathersForTier(t)); }, [])
        .filter(function (l) { return !l.out_of_stock; })[0];
      if (any) { s._leather = any.handle; if (lea) notes.push(lea.name + " is not available for " + this.style.name); }
    }
    lea = this.currentLeather();
    var mat = this.group("Material");
    if (mat && lea) {
      var me = mat.options.find(function (o) { return tierOfTerm(self.opt(o.option).name) === lea.tier; });
      if (me) s[mat.key] = me.option;
    }
    var lin = this.group("Lining skin");
    if (lin) {
      var cur = this.currentLining();
      var famOk = cur && this.opt(s[lin.key]).name === cur.family;
      if (!cur || !famOk) {
        var le = this.entry(lin, s[lin.key]) || this.activeEntries(lin)[0];
        var first = le && this.liningsForFamily(this.opt(le.option).name)[0];
        if (first) { s[lin.key] = le.option; s._lining = first.handle; }
      }
    }
    for (var pass = 0; pass < 3; pass++) {
      var changed = false;
      this.groups.forEach(function (g) {
        if (["Material", "Lining skin", "Initials", "Input", "Attach file", "Measurements", "Drop down"].indexOf(g.type) >= 0) return;
        var e = self.entry(g, s[g.key]);
        if (e && self.opt(e.option).active !== false && !self.blocked(g, e)) return;
        var ok = self.activeEntries(g).find(function (x) { return !self.blocked(g, x); });
        if (ok && ok.option !== s[g.key]) {
          if (e) notes.push(g.name + ": " + self.opt(e.option).name + " → " + self.opt(ok.option).name + " (" + self.blocked(g, e) + ")");
          s[g.key] = ok.option; changed = true;
        }
      });
      if (!changed) break;
    }
    // Do day phu thuoc kieu don
    var dd = this.group("Drop down");
    if (dd) {
      var choices = this.thicknessChoices(), m = (s._measure[dd.key] = s._measure[dd.key] || {});
      var vals = choices.map(function (c) { return c.value || c.name; });
      if (m.value && vals.indexOf(m.value) < 0) m.value = null;
      if (!m.value) {
        var padded = this.selEntry("Padded"), rel = padded && padded.extra && padded.extra.dropdownConfigRelative;
        var standard = vals.filter(function (v) { return lower(v) !== "customize"; });
        m.value = (rel && vals.indexOf(rel.defaultValue) >= 0) ? rel.defaultValue : (standard[0] || null);
      }
      var de = this.activeEntries(dd)[0];
      if (de) s[dd.key] = de.option;
    }
    // Mau canh: giu lua chon hop le
    var edge = this.selEntry("Edge finishing"), ch = edge && edge.extra && edge.extra.choices;
    if (ch && ch.length && !ch.some(function (c) { return c.id === s._edge; })) s._edge = ch[0].id;
    return notes;
  };

  // ---------- Trang thai mac dinh ----------
  Configurator.prototype.baseDefaults = function () {
    var self = this, s = { _dial: null, _measure: {}, _text: {}, _edge: null, _nologo: false, _holes: null };
    if (this.rules.racing) s._holes = this.rules.racing.default_color || null;
    this.groups.forEach(function (g) {
      var first = self.activeEntries(g)[0];
      if (first) s[g.key] = first.option;
    });
    var meas = this.group("Measurements");
    if (meas) {
      // Uu tien bang size co san (Standard); kieu chi co o nhap tu do (Nato, Fixed 2 sides) thi dien so pho bien
      var entries = this.activeEntries(meas);
      var std = entries.find(function (e) { return e.extra && (e.extra.children || []).some(function (k) { return ((k.config || {}).choices || []).length; }); }) || entries[0];
      if (std) {
        s[meas.key] = std.option;
        var m = (s._measure[meas.key] = {});
        var prefer = function (name) {
          var n = lower(name);
          return n.indexOf("lug") >= 0 ? "20" : n.indexOf("buckle") >= 0 ? "16" : n.indexOf("long end / short") >= 0 ? "115/75" : n.indexOf("long") >= 0 ? "115" : n.indexOf("short") >= 0 ? "75" : null;
        };
        ((std.extra && std.extra.children) || []).forEach(function (k) {
          var key = self.measureKey(k), cs = (k.config || {}).choices || [], want = prefer(k.name);
          if (cs.length) {
            var hit = cs.find(function (c) { return lower(c.name) === want; }) || cs[0];
            if (hit) m[key] = hit.name;
          } else if (want) m[key] = want;
        });
      }
    }
    var faces = (this.rules.watch && this.rules.watch.faces) || [];
    var df = faces.find(function (f) { return f.default; }) || faces[0];
    s._dial = df ? df.shape : null;
    return s;
  };

  Configurator.prototype.defaults = function () {
    var self = this, s = this.baseDefaults(), d = this.rules.defaults;
    if (d) {
      Object.keys(d).forEach(function (k) {
        if (META.indexOf(k) >= 0) return;
        var g = self.groups.find(function (gg) { return gg.key === k; });
        if (g && self.entry(g, d[k]) && self.opt(d[k]).active !== false) s[k] = d[k];
      });
      if (d._leather && this.leatherBy[d._leather]) s._leather = d._leather;
      if (d._lining && this.liningBy[d._lining]) s._lining = d._lining;
      if (d._edge) s._edge = d._edge;
      if (d._dial) s._dial = d._dial;
      if (d._nologo) s._nologo = true;
      if (d._holes && this.rules.racing) s._holes = d._holes;
      Object.keys(d._measure || {}).forEach(function (k) {
        if (d._measure[k] && Object.keys(d._measure[k]).some(function (x) { return d._measure[k][x]; })) s._measure[k] = clone(d._measure[k]);
      });
    }
    return s;
  };

  // ---------- Gia (giong cong thuc cua app cu) ----------
  Configurator.prototype.price = function () {
    var self = this, s = this.state, total = 0;
    if (!this.style) return 0;
    this.groups.forEach(function (g) {
      var h = s[g.key];
      if ((!h && g.type !== "Initials") || self.hidden(g)) return;
      switch (g.type) {
        case "Material":
          var lea = self.currentLeather();
          total += Number(self.style["price_" + TIER_KEY[lea ? lea.tier : "Regular"]] || 0) + Number((lea && lea.price) || 0);
          break;
        case "Lining skin":
          var lin = self.currentLining();
          total += self.priceOf(g, h) + Number((lin && lin.price) || 0);
          break;
        case "Edge finishing":
          total += self.priceOf(g, h);
          var e = self.entry(g, h), ch = self.edgeChoice(e);
          if (ch && e.extra && e.extra.type === "Painted") total += Number(ch.price || 0);
          break;
        case "Initials":
          var ip = self.initialsParts(g);
          if (ip.text && (s._text[g.key] || "").trim()) total += self.priceOf(g, ip.text.option);
          if (ip.nologo && s._nologo) total += self.priceOf(g, ip.nologo.option);
          break;
        case "Input":
          if ((s._text[g.key] || "").trim()) total += self.priceOf(g, h);
          break;
        default:
          total += self.priceOf(g, h);
      }
    });
    return Math.round(total * 100) / 100;
  };

  Configurator.prototype.edgeChoice = function (entry) {
    var list = (entry && entry.extra && entry.extra.choices) || [];
    var id = this.state._edge;
    return list.find(function (c) { return c.id === id; }) || list[0] || null;
  };

  // ---------- Lo racing (kieu co rules.racing): ve len texture da, mau lo khach chon ----------
  Configurator.prototype.holeColors = function () {
    var self = this, g = this.group("Color of stitch");
    var list = g ? g.options.map(function (e) { var o = self.opt(e.option); return o.color && !(e.extra && e.extra.isToneAndTone) ? { name: o.name, color: o.color } : null; }).filter(Boolean) : [];
    return list.length ? list : [{ name: "Black", color: "#000000" }];
  };
  Configurator.prototype.holeColor = function () {
    var list = this.holeColors(), name = this.state._holes;
    return list.find(function (c) { return c.name === name; }) || list[0];
  };
  Configurator.prototype.racingHoles = function () {
    var p = (this.rules.racing && this.rules.racing.pattern) || {}, holes = [], cols = p.cols || [[0.335, 0.445, 0.555, 0.665], [0.39, 0.5, 0.61]];
    // Day hep dan ve phia xa dong ho -> moi hang co lai vao giua (taper) de lo khong de len duong chi
    for (var r = 0; r < (p.rows || 7); r++) {
      var u = (p.u_start || 0.95) - r * (p.step || 0.022), k = (p.scale || 1) * (1 - r * (p.taper || 0));
      cols[r % cols.length].forEach(function (v) { holes.push([u, 0.5 + (v - 0.5) * k]); });
    }
    return { holes: holes, ru: p.ru || 0.0062, rv: p.rv || 0.03 };
  };

  /** Lop nen racing -> mat da cua no. rules.racing.layers[i] la mat da cua "RacingLayer_00(i+1)". */
  Configurator.prototype.racingPairs = function () {
    var r = this.rules.racing, out = {};
    if (!r || !r.layers) return out;
    r.layers.forEach(function (top, i) { out["RacingLayer_" + ("00" + (i + 1)).slice(-3)] = top; });
    return out;
  };

  // ---------- Ap len 3D ----------
  Configurator.prototype.apply3D = async function () {
    var v = this.viewer, self = this, s = this.state, token = (this._applyToken = (this._applyToken || 0) + 1);
    if (!v || !this._modelReady) return;
    var faces = (this.rules.watch && this.rules.watch.faces) || [];
    faces.forEach(function (f) { v.setVisible(f.meshes, false); });
    faces.filter(function (f) { return f.shape === s._dial; }).forEach(function (f) { v.setVisible(f.meshes, true); });
    ((this.rules.watch && this.rules.watch.colors) || []).forEach(function (c) { v.applyColor(c.meshes, c.default, false, true); });
    // logo thuong hieu tren mat so (dan sau khi bat/tat mat tron / vuong)
    if (this.data.assets.dialLogo && v.dialLogo) {
      var dialMeshes = [];
      ((this.rules.watch && this.rules.watch.colors) || []).filter(function (c) { return c.part === "Dial"; })
        .forEach(function (c) { dialMeshes = dialMeshes.concat(c.meshes); });
      try { await v.dialLogo(dialMeshes, this.data.assets.dialLogo); } catch (e) { console.warn("[3D] logo mat so", e); }
    }

    var vis = this.groups.filter(function (g) { return g.effect === "Visible"; });
    v.applyVisibility(vis.map(function (g) {
      var e = self.entry(g, s[g.key]);
      return { meshes: g.meshes, selected: e ? e.meshes : [] };
    }));
    // Model racing day du bien the: moi lop nen duoi lo chi hien cung mat da cua no
    var pairs = this.racingPairs();
    Object.keys(pairs).forEach(function (layer) {
      var top = v.byId[pairs[layer]];
      v.setVisible([layer], !!(top && top.isVisible));
    });
    var be = this.selEntry("Buckle");
    if (be && be.extra && be.extra.texture && be.extra.texture.url) {
      v.applyMetal(be.meshes, { texture: be.extra.texture.url, metalStrength: be.extra.metalStrength, roughness: be.extra.roughness });
    }

    var lea = this.currentLeather();
    var edgeG = this.group("Edge finishing"), edgeE = this.selEntry("Edge finishing");
    var stitchG = this.group("Color of stitch"), stitchE = this.selEntry("Color of stitch");
    var stitchTone = stitchE && stitchE.extra && stitchE.extra.isToneAndTone;

    for (var i = 0; i < this.groups.length; i++) {
      if (token !== this._applyToken) return; // co thay doi moi hon
      var g = this.groups[i];
      if (g.effect !== "Artwork" && g.effect !== "Color") continue;
      if (g.type === "Material" && lea) {
        var folded = edgeE && edgeE.extra && edgeE.extra.type === "Folded" && edgeG ? edgeG.meshes : [];
        var leaMeshes = g.meshes.concat(folded);
        var holeMeshes = this.rules.racing && (this.rules.racing.meshes || Object.keys(this.racingPairs()));
        if (holeMeshes && holeMeshes.length) {
          // Model co lo khoet that: phu da binh thuong, to mau lop nen duoi lo
          await v.applyLeather(leaMeshes, { artwork: lea.artwork, uv: lea.uv_map, roughness: lea.roughness });
          v.applyColor(holeMeshes, this.holeColor().color, true, false);
        } else if (this.rules.racing) {
          // Lo chi ve tren than day; cac phan trong "skip" (vd dai giu [straps]) giu da tron
          var skip = this.rules.racing.skip || ["[straps]"];
          var plain = leaMeshes.filter(function (id) { return skip.some(function (k) { return id.indexOf(k) >= 0; }); });
          leaMeshes = leaMeshes.filter(function (id) { return plain.indexOf(id) < 0; });
          await v.applyLeather(plain, { artwork: lea.artwork, uv: lea.uv_map, roughness: lea.roughness });
          var rh = this.racingHoles();
          var tex = await v.perforate({ artwork: lea.artwork, uv: lea.uv_map, color: this.holeColor().color, holes: rh.holes, ru: rh.ru, rv: rh.rv });
          if (token !== this._applyToken) return;
          await v.applyLeather(leaMeshes, { artwork: tex.artwork, uv: tex.uv, roughness: lea.roughness });
        } else {
          await v.applyLeather(leaMeshes, { artwork: lea.artwork, uv: lea.uv_map, roughness: lea.roughness });
        }
      } else if (g.type === "Lining skin") {
        var lin = this.currentLining();
        if (!lin) continue;
        var init = this.group("Initials");
        var useLogo = this.style.engraving && !s._nologo && this.data.assets.logo;
        var eng = await v.engrave({ size: g.artwork_size || "Medium", uv: lin.uv_map, artwork: lin.artwork,
          text: init ? s._text[init.key] : "", logo: useLogo ? this.data.assets.logo : null });
        if (token !== this._applyToken) return;
        await v.applyLeather(g.meshes, { artwork: eng.artwork, uv: eng.uv, roughness: lin.roughness });
      } else if (g.type === "Color of stitch" && !this.hidden(g)) {
        var color = stitchTone ? (lea && (lea.stitching_tone_color || lea.tone_color)) : this.opt(s[stitchG.key]).color;
        v.applyColor(g.meshes, color || "#ffffff", false, true);
      } else if (g.type === "Edge finishing" && edgeE && edgeE.extra && edgeE.extra.type === "Painted") {
        var ch = this.edgeChoice(edgeE);
        var ec = ch && ch.isToneAndTone ? lea && lea.tone_color : ch && ch.color;
        v.applyColor(g.meshes, ec || "#000000", true, false);
      }
    }
  };

  // ---------- Khung giao dien ----------
  Configurator.prototype.mount = async function () {
    var self = this, root = this.root;
    root.classList.add("s3d");
    root.innerHTML = "";
    this.canvas = el("canvas", { class: "s3d__canvas" });
    this.loadingEl = el("div", { class: "s3d__loading", text: "Loading 3D…" });
    this.stage = el("div", { class: "s3d__stage" }, [this.canvas, this.loadingEl]);
    this.titleEl = el("h2", { text: "" });
    this.priceEl = el("span", { class: "s3d__price" });
    this.changeBtn = el("button", { class: "s3d__change", type: "button", text: "Change style", onclick: function () { self.showPicker(); } });
    this.panel = el("div", { class: "s3d__panel" });
    this.cartBtn = el("button", { class: "s3d__cart button", type: "button", text: "Add to cart", onclick: function () { self.addToCart(false); } });
    this.buyBtn = el("button", { class: "s3d__buy button button--secondary", type: "button", text: "Checkout now", onclick: function () { self.addToCart(true); } });
    this.shareBtn = el("button", { class: "s3d__share", type: "button", text: "Share this design", onclick: function () { self.share(); } });
    this.actions = el("div", { class: "s3d__actions" }, [this.cartBtn, this.buyBtn, this.shareBtn]);
    this.msg = el("div", { class: "s3d__msg", role: "status" });
    // Man chi tiet 1 nhom (kieu Handdn): Back / Confirm thay cho nut gio hang
    this.detailBar = el("div", { class: "s3d__detailbar" }, [
      el("button", { class: "s3d__back", type: "button", text: "Back", onclick: function () { self.closeGroup(); } }),
      el("button", { class: "s3d__confirm", type: "button", text: "Confirm", onclick: function () { self.closeGroup(); } }),
    ]);
    this.stagePrice = el("span", { class: "s3d__tagprice" });
    // 3D chi de minh hoa lua chon; day that lam tay dep hon nhieu
    this.stage.appendChild(el("div", { class: "s3d__disc" }, [el("b", { text: "3D preview for reference only." }), " Your strap is cut and stitched by hand \u2014 the real leather looks far richer in person."]));
    this.stage.appendChild(el("button", { class: "s3d__tag", type: "button", onclick: function () { self.closeGroup(); self.addToCart(false); } },
      [el("span", { class: "s3d__tagtxt", text: "Complete" }), this.stagePrice]));
    this.tryBtn = el("button", { class: "s3d__tryon", type: "button", onclick: function () { self.tryOn(); } }, [
      el("span", { class: "s3d__tryon-ic", "aria-hidden": "true", text: "✋" }), "Try on your wrist"]);
    this.stage.appendChild(this.tryBtn);
    root.appendChild(this.stage);
    this.side = el("div", { class: "s3d__side" }, [
      el("div", { class: "s3d__title" }, [el("div", {}, [this.titleEl, this.styles.length > 1 && !this.opts.lockStyle ? this.changeBtn : null]), this.priceEl]),
      this.panel, this.detailBar, this.actions, this.msg,
    ]);
    root.appendChild(this.side);

    this.viewer = new global.StrapViewer(this.canvas, this.data.assets);
    await this.viewer.init();

    var params = new URLSearchParams(location.search);
    // Uu tien ma trong link (?d=), neu khong co thi lay ma cua san pham (trang san pham co 3D nhung san)
    var saved = (params.get("d") && decode(params.get("d"))) || (this.opts.initialCode && decode(this.opts.initialCode));
    var wanted = (saved && saved.style) || params.get("style") || this.opts.initialStyle;
    var found = this.styles.find(function (s) { return s.handle === wanted; });
    if (found) return this.setStyle(found.handle, saved && saved.style === found.handle ? saved.state : null);
    if (this.opts.showPicker !== false && this.styles.length > 1) return this.showPicker();
    return this.setStyle(this.styles[0].handle);
  };

  Configurator.prototype.showPicker = function () {
    var self = this;
    this.picking = true;
    this._styleToken = (this._styleToken || 0) + 1;
    if (!this.style) { this.loadingEl.hidden = false; this.loadingEl.textContent = "Choose a strap style to start"; }
    this.titleEl.textContent = "Choose your strap style";
    this.priceEl.textContent = "";
    this.changeBtn.hidden = true;
    this.actions.hidden = true; this.openKey = null; if (this.side) this.side.classList.remove("is-detail"); this.root.classList.add("is-picking");
    this.msg.textContent = "";
    this.panel.innerHTML = "";
    this.panel.appendChild(el("div", { class: "s3d__styles" }, this.styles.map(function (st) {
      var from = Math.min.apply(null, ["price_regular", "price_exotic", "price_non_leather"].map(function (k) { return Number(st[k]) || Infinity; }));
      return el("button", { class: "s3d__style" + (self.style && self.style.handle === st.handle ? " is-active" : ""), type: "button",
        onclick: function () { self.setStyle(st.handle); } }, [
        st.image ? el("img", { src: st.image, alt: st.name, loading: "lazy" }) : null,
        el("strong", { text: st.name }),
        isFinite(from) ? el("small", { text: "from " + money(from) }) : null,
      ]);
    })));
  };

  Configurator.prototype.setStyle = async function (handle, savedState) {
    var st = this.styles.find(function (s) { return s.handle === handle; });
    if (!st) return;
    var prev = this.style && this.state;
    this.picking = false;
    this.style = st;
    this.rules = st.rules;
    this.groups = st.rules.groups;
    this.state = this.defaults();
    if (savedState) {
      var self = this;
      Object.keys(savedState).forEach(function (k) { self.state[k] = clone(savedState[k]); });
    } else if (prev) {
      // Doi kieu day: giu mau da, lot, mau chi neu kieu moi cung co
      if (prev._leather) this.state._leather = prev._leather;
      if (prev._lining) this.state._lining = prev._lining;
    }
    this.fix();
    this.titleEl.textContent = this.opts.title || st.name;
    this.changeBtn.hidden = false;
    this.actions.hidden = false; this.root.classList.remove("is-picking");
    this.openKey = null;
    this.renderPanel();
    this.renderPrice();
    this._modelReady = false;
    this.loadingEl.hidden = false;
    this.loadingEl.textContent = "Loading 3D…";
    var token = (this._styleToken = (this._styleToken || 0) + 1);
    try {
      await this.viewer.loadModel(st.model_url);
      if (token !== this._styleToken) return;
      this._modelReady = true;
      this.viewer.resetView(); // luon bat dau o mat truoc
      await this.apply3D();
      // Model goc co texture mac dinh in chu thuong hieu cu -> giu man che cho toi khi texture da that da tai xong
      try { await this.viewer.scene.whenReadyAsync(); } catch (e) { /* van mo khung 3D */ }
    } catch (e) {
      console.error("[3D]", e);
      this.say("Could not load the 3D model. Please refresh the page.", true);
    } finally {
      if (token === this._styleToken) this.loadingEl.hidden = true;
    }
  };

  Configurator.prototype.change = function (patch, group) {
    Object.assign(this.state, patch);
    var notes = this.fix();
    this.renderPanel(group && group.key);
    this.renderPrice();
    if (notes.length) this.say("Updated: " + notes.join("; "), false);
    var self = this;
    clearTimeout(this._t);
    this._t = setTimeout(function () { self.apply3D(); }, 30);
  };

  Configurator.prototype.renderPrice = function () {
    var t = money(this.price());
    this.priceEl.textContent = t;
    if (this.stagePrice) this.stagePrice.textContent = this.picking ? "" : t;
  };

  Configurator.prototype.panelItems = function () {
    var self = this, items = [];
    var dialFaces = (this.rules.watch && this.rules.watch.faces) || [];
    if (dialFaces.length > 1) {
      items.push({ g: { key: "_dial", name: "Watch dial", image: "watch-dial.png" }, body: function () {
        return el("div", { class: "s3d__chips" }, dialFaces.map(function (f) {
          return self.chip(f.shape, self.state._dial === f.shape, function () { self.change({ _dial: f.shape }, { key: "_dial" }); });
        }));
      } });
    }
    var racing = this.rules.racing;
    this.groups.forEach(function (g) {
      if (self.hidden(g)) return;
      items.push({ g: g, body: function () { return self.renderGroup(g); } });
      if (racing && g.type === "Material") items.push(self.holesItem(racing, g));
    });
    return items;
  };

  // dien thoai: mo nhom ngay tai cho trong danh sach (accordion) thay vi man chi tiet rieng
  Configurator.prototype.isInline = function () { return window.innerWidth <= 989; };

  Configurator.prototype.renderPanel = function (openKey) {
    var self = this, panel = this.panel;
    if (this.picking) return;
    if (openKey !== undefined) this.openKey = openKey;
    var items = this.panelItems(), inline = this.isInline();
    var open = items.find(function (i) { return i.g.key === self.openKey; });
    var keepScroll = open && this._lastOpen === open.g.key ? panel.scrollTop : 0;
    panel.innerHTML = "";
    this.side.classList.toggle("is-detail", !!open && !inline);
    this.side.classList.toggle("is-inline", inline);
    if (open && !inline) {
      var g = open.g, body = open.body();
      panel.appendChild(el("div", { class: "s3d__dhead" }, [
        el("span", { class: "s3d__dname" }, [g.name, g.required ? el("i", { text: " *" }) : null]),
        el("span", { class: "s3d__dval", text: this.summary(g) }),
      ]));
      if (g.tooltip) panel.appendChild(el("p", { class: "s3d__dnote", text: g.tooltip }));
      if (body) panel.appendChild(el("div", { class: "s3d__body" }, [body]));
      this._lastOpen = g.key;
      panel.scrollTop = keepScroll;
      return;
    }
    this._lastOpen = open ? open.g.key : null;
    items.forEach(function (i) {
      var body = i.body();
      if (!body) return;
      var isOpen = !!open && i.g.key === open.g.key;
      panel.appendChild(self.card(i.g, isOpen));
      if (isOpen) {
        panel.appendChild(el("div", { class: "s3d__inline" }, [
          i.g.tooltip ? el("p", { class: "s3d__dnote", text: i.g.tooltip }) : null,
          el("div", { class: "s3d__body" }, [body]),
          el("button", { class: "s3d__done", type: "button", text: "Done", onclick: function () { self.closeGroup(); } }),
        ]));
      }
    });
    if (!inline && this._listScroll) panel.scrollTop = this._listScroll;
  };

  Configurator.prototype.groupImage = function (g) {
    var map = this.opts.groupImages || {}, src = g.image || "";
    return map[src.split("/").pop()] || null;
  };

  Configurator.prototype.card = function (g, isOpen) {
    var self = this, img = isOpen ? null : this.groupImage(g), val = this.summary(g);
    return el("button", { class: "s3d__card" + (isOpen ? " is-open" : ""), type: "button", "data-gkey": g.key, "aria-expanded": isOpen ? "true" : "false",
      onclick: function () { if (isOpen) self.closeGroup(); else self.openGroup(g); } }, [
      el("span", { class: "s3d__card-h" }, [
        el("span", { class: "s3d__gname" }, [g.name, g.required ? el("i", { text: " *" }) : null]),
        el("span", { class: "s3d__gval", text: val }),
      ]),
      img ? el("img", { class: "s3d__card-img", src: img, alt: "", loading: "lazy" }) : null,
    ]);
  };

  Configurator.prototype.openGroup = function (g) {
    this._listScroll = this.panel.scrollTop;
    this.openKey = g.key;
    if (g.camera && this.viewer) this.viewer.focus(g.camera);
    this.renderPanel();
    if (this.isInline()) { this.alignCard(g.key, false); return; }
    this.panel.scrollTop = 0;
    this.revealPanel();
  };

  // vi tri day khung 3D dang dinh tren man hinh (0 neu khung khong dinh)
  Configurator.prototype.stageBottom = function () {
    if (!this.stage) return 0;
    var cs = getComputedStyle(this.stage);
    if (cs.position === "fixed") return this.stage.getBoundingClientRect().bottom;
    // sticky: lay vi tri khi khung da dinh (top + chieu cao), vi sau khi cuon khung moi dinh len
    if (cs.position === "sticky") return (parseFloat(cs.top) || 0) + this.stage.getBoundingClientRect().height;
    return 0;
  };

  // dua the nhom len sat duoi khung 3D; onlyIfHidden: chi cuon khi the dang bi khung 3D che
  Configurator.prototype.alignCard = function (key, onlyIfHidden) {
    var self = this;
    requestAnimationFrame(function () {
      var c = self.panel.querySelector('[data-gkey="' + key + '"]');
      if (!c) return;
      var d = c.getBoundingClientRect().top - self.stageBottom() - 2;
      if (onlyIfHidden && d >= 0) return;
      if (Math.abs(d) > 6) window.scrollBy({ top: d, behavior: "instant" });
    });
  };

  // dien thoai (che do cu): dua dau phan lua chon len sat duoi khung 3D
  Configurator.prototype.revealPanel = function (onlyIfHidden) {
    if (window.innerWidth > 989) return;
    var panel = this.panel, self = this;
    requestAnimationFrame(function () {
      var r = panel.getBoundingClientRect(), d = r.top - self.stageBottom() - 4;
      if (Math.abs(d) < 8 || (onlyIfHidden && d > 0)) return;
      window.scrollBy({ top: d, behavior: "smooth" });
    });
  };

  Configurator.prototype.closeGroup = function () {
    if (this.openKey == null) return;
    var key = this.openKey;
    this.openKey = null;
    if (this.viewer) this.viewer.resetView();
    this.renderPanel();
    // giu nguyen cho dang xem: the vua dong nam ngay duoi khung 3D, the ke tiep lien sau
    if (this.isInline()) this.alignCard(key, true); else this.revealPanel(true);
  };

  Configurator.prototype.holesItem = function (racing, matGroup) {
    var self = this;
    var g = { key: "_holes", name: racing.label || "Racing holes color", required: true, camera: matGroup.camera };
    return { g: g, body: function () {
      var cur = self.holeColor();
      return el("div", { class: "s3d__chips" }, self.holeColors().map(function (c) {
        return self.chip(c.name, cur && cur.name === c.name, function () { self.change({ _holes: c.name }, g); }, { color: c.color });
      }));
    } };
  };

  Configurator.prototype.measureText = function (sep) {
    var self = this, g = this.group("Measurements"), m = (g && this.state._measure[g.key]) || {};
    return this.measureChildren().map(function (k) {
      var v = m[self.measureKey(k)];
      return v ? k.name + ": " + v + " mm" : null;
    }).filter(Boolean).join(sep || " · ");
  };

  Configurator.prototype.summary = function (g) {
    var s = this.state;
    if (g.key === "_dial") return s._dial || "";
    if (g.key === "_holes") { var hc = this.holeColor(); return hc ? hc.name : ""; }
    if (g.type === "Material") { var l = this.currentLeather(); return l ? l.name : ""; }
    if (g.type === "Lining skin") { var n = this.currentLining(); return n ? n.name : ""; }
    if (g.type === "Initials") return [(s._text[g.key] || "").trim(), s._nologo ? "no logo" : ""].filter(Boolean).join(" · ") || "—";
    if (g.type === "Input") return (s._text[g.key] || "").trim() || "—";
    if (g.type === "Measurements") return this.measureText(", ") || this.opt(s[g.key]).name || "";
    if (g.type === "Drop down") return (s._measure[g.key] || {}).value || "Select";
    return this.opt(s[g.key]).name || "";
  };

  Configurator.prototype.chip = function (label, active, onclick, extra) {
    extra = extra || {};
    return el("button", { class: "s3d__chip" + (active ? " is-active" : "") + (extra.disabled ? " is-disabled" : ""), type: "button",
      onclick: extra.disabled ? null : onclick, title: extra.disabled || extra.title, "aria-disabled": extra.disabled ? "true" : null },
      [extra.image ? el("img", { src: extra.image, alt: "", loading: "lazy" }) : null,
       extra.color ? el("span", { class: "s3d__dot", style: "background:" + extra.color }) : null,
       el("span", { text: label }),
       extra.price ? el("small", { text: "+" + money(extra.price) }) : null]);
  };

  Configurator.prototype.renderGroup = function (g) {
    var self = this, s = this.state;
    var entries = this.activeEntries(g);
    var optChips = function () {
      return el("div", { class: "s3d__chips" }, entries.map(function (e) {
        var o = self.opt(e.option);
        return self.chip(o.name, s[g.key] === e.option, function () { var p = {}; p[g.key] = e.option; self.change(p, g); },
          { image: o.image, color: g.type === "Color of stitch" ? (o.color || null) : null, price: self.priceOf(g, e.option),
            title: o.tooltip, disabled: self.blocked(g, e) });
      }));
    };
    switch (g.type) {
      case "Material": return this.renderLeather(g);
      case "Lining skin": return this.renderLining(g);
      case "Edge finishing": return this.renderEdge(g, optChips());
      case "Measurements": return this.renderMeasure(g, optChips());
      case "Drop down": return this.renderDropdown(g);
      case "Initials": return this.renderInitials(g);
      case "Input":
        var e0 = entries[0], ex = (e0 && e0.extra) || {};
        var input = el(ex.isTextarea ? "textarea" : "input", { class: "s3d__input", rows: 3, placeholder: this.opt(e0 && e0.option).name || "",
          oninput: function (ev) { s._text[g.key] = ev.target.value; s[g.key] = e0 && e0.option; self.renderPrice(); } });
        input.value = s._text[g.key] || "";
        return input;
      default: return optChips();
    }
  };

  Configurator.prototype.renderLeather = function (g) {
    var self = this, s = this.state, cur = this.currentLeather();
    var tiers = ["Regular", "Exotic", "Non-leather"].filter(function (t) { return self.leathersForTier(t).length; });
    var tier = this._tier && tiers.indexOf(this._tier) >= 0 ? this._tier : (cur ? cur.tier : tiers[0]);
    var list = this.leathersForTier(tier);
    var fams = [];
    list.forEach(function (l) { if (fams.indexOf(l.family) < 0) fams.push(l.family); });
    var fam = this._family && fams.indexOf(this._family) >= 0 ? this._family : (cur && cur.tier === tier ? cur.family : fams[0]);
    var base = this.style["price_" + TIER_KEY[tier]] || 0;
    return el("div", { class: "s3d__mat" }, [
      el("div", { class: "s3d__tiers" }, tiers.map(function (t) {
        return el("button", { class: "s3d__tier" + (t === tier ? " is-active" : ""), type: "button",
          onclick: function () { self._tier = t; self._family = null; self.renderPanel(); } },
          [el("b", { text: t }), el("small", { text: "(" + money(self.style["price_" + TIER_KEY[t]]) + ")" })]);
      })),
      el("div", { class: "s3d__matbody" }, [
        el("div", { class: "s3d__fams" }, fams.map(function (f) {
          return el("button", { class: "s3d__fam" + (f === fam ? " is-active" : ""), type: "button", text: f,
            onclick: function () { self._family = f; self._tier = tier; self.renderPanel(); } });
        })),
        el("div", { class: "s3d__swatches s3d__swatches--mat" }, list.filter(function (l) { return l.family === fam; }).map(function (l) {
          return el("button", { class: "s3d__swatch" + (s._leather === l.handle ? " is-active" : "") + (l.out_of_stock ? " is-out" : ""), type: "button",
            title: l.name + (l.out_of_stock ? " (out of stock)" : ""), disabled: l.out_of_stock,
            onclick: function () { self.change({ _leather: l.handle }, g); } },
            [el("img", { src: l.swatch, alt: l.name, loading: "lazy" }), el("span", { class: "s3d__swn", text: l.name }),
             el("small", { text: "(" + money(base + Number(l.price || 0)) + ")" }), l.out_of_stock ? el("em", { text: "Out of stock" }) : null]);
        })),
      ]),
    ]);
  };

  Configurator.prototype.renderLining = function (g) {
    var self = this, s = this.state;
    var entries = this.activeEntries(g).filter(function (e) { return self.liningsForFamily(self.opt(e.option).name).length; });
    var curFam = this.opt(s[g.key]).name;
    return el("div", {}, [
      el("div", { class: "s3d__tabs s3d__tabs--small" }, entries.map(function (e) {
        var o = self.opt(e.option);
        return self.chip(o.name, s[g.key] === e.option, function () {
          var first = self.liningsForFamily(o.name)[0];
          var p = {}; p[g.key] = e.option; p._lining = first && first.handle;
          self.change(p, g);
        }, { price: self.priceOf(g, e.option) });
      })),
      el("div", { class: "s3d__swatches" }, this.liningsForFamily(curFam).map(function (l) {
        return el("button", { class: "s3d__swatch" + (s._lining === l.handle ? " is-active" : "") + (l.out_of_stock ? " is-out" : ""), type: "button",
          title: l.name, disabled: l.out_of_stock, onclick: function () { self.change({ _lining: l.handle }, g); } },
          [el("img", { src: l.swatch, alt: l.name, loading: "lazy" }), el("span", { text: l.name + (Number(l.price) ? " +" + money(l.price) : "") })]);
      })),
    ]);
  };

  Configurator.prototype.renderEdge = function (g, chips) {
    var self = this, e = this.entry(g, this.state[g.key]);
    if (!e || !e.extra || e.extra.type !== "Painted" || !(e.extra.choices || []).length) return chips;
    var cur = this.edgeChoice(e);
    return el("div", {}, [chips, el("div", { class: "s3d__chips" }, e.extra.choices.map(function (c) {
      return self.chip(c.name, cur && cur.id === c.id, function () { self.change({ _edge: c.id }, g); },
        { color: c.isToneAndTone ? null : c.color, image: c.image && c.image.url, price: Number(c.price || 0), title: c.tooltip });
    }))]);
  };

  Configurator.prototype.renderMeasure = function (g, chips) {
    var self = this, s = this.state, e = this.entry(g, s[g.key]);
    var kids = (e && e.extra && e.extra.children) || [];
    var m = (s._measure[g.key] = s._measure[g.key] || {});
    var update = function (key, val) { m[key] = val; var notes = self.fix(); self.renderPrice(); if (notes.length) { self.say("Updated: " + notes.join("; "), false); self.renderPanel(); self.apply3D(); } };
    return el("div", {}, [chips, el("div", { class: "s3d__fields" }, kids.map(function (k) {
      var key = self.measureKey(k), choices = (k.config || {}).choices || [];
      var field;
      if (choices.length) {
        field = el("select", { class: "s3d__input", onchange: function (ev) { update(key, ev.target.value); } },
          [el("option", { value: "", text: "Select" })].concat(choices.map(function (c) { return el("option", { value: c.name, text: c.name + " mm", selected: m[key] === c.name }); })));
      } else {
        field = el("input", { class: "s3d__input", type: "number", min: 0, step: "0.5", placeholder: "mm", value: m[key] || "", onchange: function (ev) { update(key, ev.target.value); } });
      }
      return el("label", { class: "s3d__field" }, [el("span", { text: k.name + " (mm)" }), field]);
    }))]);
  };

  Configurator.prototype.renderDropdown = function (g) {
    var self = this, s = this.state, e = this.activeEntries(g)[0];
    var choices = this.thicknessChoices();
    var m = (s._measure[g.key] = s._measure[g.key] || {});
    return el("select", { class: "s3d__input", onchange: function (ev) { m.value = ev.target.value; s[g.key] = e.option; self.renderPrice(); self.renderPanel(); } },
      [el("option", { value: "", text: "Select" })].concat(choices.map(function (c) {
        var v = c.value || c.name;
        return el("option", { value: v, text: (c.name || c.value).trim(), selected: m.value === v });
      })));
  };

  Configurator.prototype.renderInitials = function (g) {
    var self = this, s = this.state, ip = this.initialsParts(g);
    var textOpt = ip.text ? this.opt(ip.text.option) : {};
    var input = el("input", { class: "s3d__input", maxlength: 10, placeholder: textOpt.name || "Your initials (max 10)",
      onfocus: function () { if (g.camera && self.viewer) self.viewer.focus(g.camera); }, // xoay toi cho khac chu
      oninput: function (ev) {
        s._text[g.key] = ev.target.value;
        if (ip.text) s[g.key] = ip.text.option;
        self.renderPrice(); clearTimeout(self._t);
        self._t = setTimeout(function () { self.apply3D(); }, 400);
      } });
    input.value = s._text[g.key] || "";
    var parts = [el("label", { class: "s3d__field" }, [el("span", { text: "Text stamped on the lining (max 10 characters)" }), input])];
    if (ip.nologo && this.style.engraving) {
      var o = this.opt(ip.nologo.option);
      parts.push(el("label", { class: "s3d__check" }, [
        el("input", { type: "checkbox", checked: !!s._nologo, onchange: function (ev) { self.change({ _nologo: ev.target.checked }, g); } }),
        el("span", { text: o.name + (this.priceOf(g, ip.nologo.option) ? " (+" + money(this.priceOf(g, ip.nologo.option)) + ")" : "") }),
      ]));
    }
    var desc = ip.text && ip.text.extra && ip.text.extra.description;
    if (desc) parts.push(el("small", { class: "s3d__note", text: desc }));
    return el("div", { class: "s3d__initials" }, parts);
  };

  // ---------- Gio hang ----------
  Configurator.prototype.properties = function () {
    var self = this, s = this.state, p = {};
    if (this.opts.productTitle) p["Product"] = this.opts.productTitle;
    p["Style of Strap"] = this.style.name;
    if (s._dial) p["Watch dial"] = s._dial;
    if (this.rules.racing) p[this.rules.racing.label || "Racing holes color"] = this.holeColor().name;
    this.groups.forEach(function (g) {
      if (self.hidden(g)) return;
      var h = s[g.key], o = self.opt(h), price = self.priceOf(g, h), tag = price ? " (" + money(price) + ")" : "";
      switch (g.type) {
        case "Material":
          var l = self.currentLeather();
          if (l) p[g.name] = l.tier + " / " + l.family + " / " + l.name + " (" + money(self.style["price_" + TIER_KEY[l.tier]] + Number(l.price || 0)) + ")";
          break;
        case "Lining skin":
          var n = self.currentLining();
          if (n) p[g.name] = o.name + " / " + n.name + (price + Number(n.price || 0) ? " (" + money(price + Number(n.price || 0)) + ")" : "");
          break;
        case "Measurements":
          p[g.name] = (o.name || "") + (self.measureText() ? " – " + self.measureText() : "");
          break;
        case "Drop down":
          if ((s._measure[g.key] || {}).value) p[g.name] = s._measure[g.key].value;
          break;
        case "Edge finishing":
          var ent = self.entry(g, h), ch = self.edgeChoice(ent);
          p[g.name] = o.name + (ch && (ent.extra || {}).type === "Painted" ? " / " + ch.name : "") + tag;
          break;
        case "Initials":
          var ip2 = self.initialsParts(g);
          if ((s._text[g.key] || "").trim()) p[g.name] = s._text[g.key].trim();
          if (ip2.nologo && s._nologo) { var np = self.priceOf(g, ip2.nologo.option); p[g.name + " (logo)"] = self.opt(ip2.nologo.option).name + (np ? " (" + money(np) + ")" : ""); }
          break;
        case "Input":
          if ((s._text[g.key] || "").trim()) p[g.name] = s._text[g.key].trim();
          break;
        default:
          if (o.name) p[g.name] = o.name + tag;
      }
    });
    var code = encode({ style: this.style.handle, state: s });
    p["_design"] = code;
    if (this.opts.designUrl) p["Design link"] = this.opts.designUrl(code);
    return p;
  };

  Configurator.prototype.validate = function () {
    var self = this, s = this.state, missing = [];
    this.groups.forEach(function (g) {
      if (!g.required || self.hidden(g)) return;
      if (g.type === "Material" && !s._leather) missing.push(g.name);
      else if (g.type === "Measurements") {
        var m = s._measure[g.key] || {};
        if (self.measureChildren().some(function (k) { return !m[self.measureKey(k)]; })) missing.push(g.name);
      } else if (g.type === "Drop down" && !(s._measure[g.key] || {}).value) missing.push(g.name);
      else if (g.type === "Input" && !(s._text[g.key] || "").trim()) missing.push(g.name); // vd Nato: kich thuoc dong ho, co tay
      else if (!s[g.key] && ["Input", "Initials", "Attach file"].indexOf(g.type) < 0) missing.push(g.name);
    });
    return missing;
  };

  Configurator.prototype.addToCart = async function (checkout) {
    var missing = this.validate();
    if (missing.length) { this.say("Please choose: " + missing.join(", "), true); var mk = this.groups.find(function (g) { return g.name === missing[0]; }).key; this.renderPanel(mk); if (this.isInline()) this.alignCard(mk, false); return; }
    var price = this.price(), id = this.opts.variantForPrice && this.opts.variantForPrice(price);
    if (!id) { this.say("Sorry, this design (" + money(price) + ") cannot be added online. Please contact us.", true); return; }
    var props = this.properties();
    var ok = await Configurator.confirmSheet(Object.assign({ Price: money(price) }, props), {
      note: "The 3D preview is a guide — your handmade strap will look even richer in person.",
      ok: checkout ? "Confirm & checkout" : "Confirm & add to cart", alt: "Keep editing"
    });
    if (!ok) return;
    this.cartBtn.disabled = this.buyBtn.disabled = true;
    try {
      await this.opts.addToCart(id, props, price);
      this.say("Added to cart", false);
      if (this.opts.onAdded) this.opts.onAdded(checkout);
    } catch (e) {
      console.error("[3D]", e);
      this.say("Sorry, we could not add this design to your cart. Please try again.", true);
    } finally {
      this.cartBtn.disabled = this.buyBtn.disabled = false;
    }
  };

  /** Thu day len anh co tay khach (anh day nhin thang, nen trong suot). */
  Configurator.prototype.tryOn = async function () {
    if (!this.viewer || !this.viewer.captureFront || !global.StrapTryOn) { this.say("Try-on is not available on this device.", true); return; }
    var b = this.tryBtn; b.disabled = true;
    try {
      var png = await this.viewer.captureFront(1400);
      global.StrapTryOn.open(png, { title: "Try it on your wrist" });
    } catch (e) {
      console.error("[3D] try-on", e);
      this.say("Sorry, try-on could not start. Please try again.", true);
    } finally { b.disabled = false; }
  };

  /** Link mo lai dung thiet ke dang xem (gui cho ban be / luu lai). */
  Configurator.prototype.shareUrl = function () {
    var code = encode({ style: this.style.handle, state: this.state });
    if (this.opts.designUrl) return this.opts.designUrl(code);
    var u = new URL(location.href);
    u.searchParams.delete("style"); u.searchParams.set("d", code);
    return u.toString();
  };

  Configurator.prototype.share = async function () {
    var url = this.shareUrl(), title = "My " + this.style.name + " strap design";
    try {
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) { await navigator.share({ title: title, url: url }); return; }
      await navigator.clipboard.writeText(url);
      this.say("Link copied – paste it anywhere to reopen this design.", false);
    } catch (e) {
      if (e && e.name === "AbortError") return;
      window.prompt("Copy this link:", url);
    }
  };

  Configurator.prototype.say = function (text, isError) {
    this.msg.textContent = text;
    this.msg.className = "s3d__msg" + (isError ? " is-error" : " is-ok");
  };

  /**
   * Thong so day day du cua 1 ma thiet ke (khong can khung 3D): dung cho don "as shown" de xuong biet
   * lot, chi, do day, vien... giong don dat qua 3D. skip: regex ten nhom bo qua (khach da chon o form).
   */
  Configurator.specFor = function (data, code, skip) {
    var d = decode(code);
    if (!d || !d.style) return null;
    var c = new Configurator(null, data, {});
    var st = c.styles.find(function (x) { return x.handle === d.style; });
    if (!st) return null;
    c.style = st; c.rules = st.rules; c.groups = st.rules.groups;
    c.state = c.defaults();
    Object.keys(d.state || {}).forEach(function (k) { c.state[k] = clone(d.state[k]); });
    c.fix();
    var p = c.properties(), out = {};
    var skipNames = {};
    c.groups.forEach(function (g) {
      if (["Measurements", "Input", "Initials", "Attach file"].indexOf(g.type) >= 0 || (skip && skip.test(g.name))) skipNames[g.name] = 1;
    });
    Object.keys(p).forEach(function (k) {
      if (k === "Watch dial" || skipNames[k] || /\(logo\)$/.test(k) && skipNames[k.replace(/ \(logo\)$/, "")]) return;
      out[k] = String(p[k]).replace(/ \(\$[\d.,]+\)/g, "");  // bo gia trong ngoac: don "as shown" tinh theo gia san pham
    });
    out["_design"] = encode({ style: st.handle, state: c.state });
    return out;
  };

  /**
   * Bang xac nhan thong so truoc khi them gio (dung chung trang 3D + trang san pham).
   * props: {ten: gia tri} (bo qua khoa bat dau "_" va "Design link"). opts: {title, note, ok, alt, onAlt}
   * Tra ve Promise<true|false>.
   */
  Configurator.confirmSheet = function (props, opts) {
    opts = opts || {};
    if (!document.getElementById("gcf-css")) {
      var st = document.createElement("style"); st.id = "gcf-css";
      st.textContent = ".gcf{position:fixed;inset:0;z-index:2147483000;background:rgba(20,19,17,.5);display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .2s;font-family:inherit}" +
        ".gcf.is-on{opacity:1}.gcf__c{position:relative;width:min(480px,100%);max-height:calc(100vh - 32px);display:flex;flex-direction:column;background:#fff;color:#1d1c1a;border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.25);transform:translateY(12px);transition:transform .2s}" +
        ".gcf.is-on .gcf__c{transform:none}.gcf__h{padding:20px 22px 6px}.gcf__h h3{margin:0 0 4px;font-family:'Cormorant Garamond',Georgia,serif;font-weight:400;font-size:26px;line-height:1.15}" +
        ".gcf__h p{margin:0;font-size:13.5px;color:#66625b;line-height:1.5}.gcf__x{position:absolute;top:8px;right:10px;border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:#8a857c}" +
        ".gcf__l{margin:10px 22px 0;padding:0;overflow:auto;border-top:1px solid #eee7dc}.gcf__r{display:flex;gap:12px;justify-content:space-between;padding:9px 0;border-bottom:1px solid #f1ece4;font-size:14px;line-height:1.4}" +
        ".gcf__r dt{color:#7a756c;flex:0 0 42%}.gcf__r dd{margin:0;text-align:right;font-weight:600;word-break:break-word}" +
        ".gcf__n{margin:12px 22px 0;font-size:12.5px;color:#7a756c;font-style:italic;line-height:1.5}.gcf__b{padding:16px 22px 20px;display:grid;gap:10px}" +
        ".gcf__ok,.gcf__alt{height:50px;border-radius:6px;font:inherit;font-size:15px;font-weight:600;cursor:pointer}.gcf__ok{background:#1d1c1a;color:#fff;border:0}.gcf__alt{background:#fff;color:#1d1c1a;border:1px solid #d9d2c6}" +
        "@media (max-width:560px){.gcf{align-items:flex-end;padding:0}.gcf__c{border-radius:14px 14px 0 0;max-height:92vh}.gcf__b{padding-bottom:calc(20px + env(safe-area-inset-bottom))}}";
      document.head.appendChild(st);
    }
    return new Promise(function (resolve) {
      var rows = Object.keys(props || {}).filter(function (k) { return k.charAt(0) !== "_" && k !== "Design link" && String(props[k]).trim(); })
        .map(function (k) { return el("div", { class: "gcf__r" }, [el("dt", { text: k }), el("dd", { text: String(props[k]) })]); });
      var box, done = function (v) { box.classList.remove("is-on"); document.removeEventListener("keydown", onKey); setTimeout(function () { box.remove(); }, 200); resolve(v); };
      var onKey = function (e) { if (e.key === "Escape") done(false); };
      var btns = [el("button", { class: "gcf__ok", type: "button", text: opts.ok || "Confirm & add to cart", onclick: function () { done(true); } })];
      if (opts.alt) btns.push(el("button", { class: "gcf__alt", type: "button", text: opts.alt, onclick: function () { done(false); if (opts.onAlt) opts.onAlt(); } }));
      box = el("div", { class: "gcf", role: "dialog", "aria-modal": "true", "aria-label": opts.title || "Confirm your strap" }, [
        el("div", { class: "gcf__c" }, [
          el("button", { class: "gcf__x", type: "button", "aria-label": "Close", text: "×", onclick: function () { done(false); } }),
          el("div", { class: "gcf__h" }, [el("h3", { text: opts.title || "Confirm your strap" }), el("p", { text: opts.lead || "Please check every detail — we cut and stitch your strap exactly as listed." })]),
          el("dl", { class: "gcf__l" }, rows),
          opts.note ? el("p", { class: "gcf__n", text: opts.note }) : null,
          el("div", { class: "gcf__b" }, btns)
        ])
      ]);
      box.addEventListener("click", function (e) { if (e.target === box) done(false); });
      document.addEventListener("keydown", onKey);
      document.body.appendChild(box);
      requestAnimationFrame(function () { box.classList.add("is-on"); });
      box.querySelector(".gcf__ok").focus();
    });
  };

  global.StrapConfigurator = Configurator;
  global.StrapConfigurator.decode = decode;
})(window);
